import type { EpisodeProgress } from './progress'

// P1.1 fix — completion is monotonic: once an episode has been marked
// completed, no later write (e.g. replaying it and leaving before reaching
// the completion threshold again) may downgrade it back to false. This is
// the one place that decides how a new progress write combines with
// whatever was already stored, so ProgressRepository implementations
// (Local now, Cosmos in P5) never have to re-derive this rule themselves.
//
// Position and startedAt always reflect the latest write (resuming a
// replay should still track where you are); completed and completedAt are
// "sticky" once true.
export function mergeProgress(existing: EpisodeProgress | null, incoming: EpisodeProgress): EpisodeProgress {
  if (!existing) return incoming

  const completed = existing.completed || incoming.completed
  return {
    ...incoming,
    completed,
    completedAt: completed ? existing.completedAt ?? incoming.completedAt : incoming.completedAt,
  }
}
